export enum EBadge {
  NONE = 'none',
  DIGITAL_EXCELLENCE_LOGO = 'digitalExcellenceLogo',
  VOLLTREFFER = 'volltreffer',
}
